import { deviceType } from './constant'

/**
 * 根据ua返回是否是微信:微信返回true
 */
const isWechat = function() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf("micromessenger") >= 0 || ua.indexOf("windows phone") >= 0) {
    return true;
  } else {
    return false;
  }
};
export const isIos = function() {
  var ua = window.navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) {
    return true;
  } else {
    return false;
  }
};

export const deviceCheck = function(device: deviceType) {
  const ua =  window.navigator.userAgent
  if (device === deviceType.Ios && /iphone|ipad|ipod/i.test(ua)) {
    return true;
  } else if (device === deviceType.Android && /Android/i.test(ua)) {
    return true
  } else if (device === deviceType.iPad && /iPad/i.test(ua)) {
    return true
  } else if (device === deviceType.PC && IsPC()){
    return true
  }
}

export const getDevice = function() {
  if(deviceCheck(deviceType.iPad)){
    return 'iPad'
  }
  if(deviceCheck(deviceType.Ios)){
    return 'Ios'
  }
  if(deviceCheck(deviceType.Android)){
    return 'Android'
  }
  if(deviceCheck(deviceType.PC)){
    return 'PC'
  }
  return 'otherDevice'
}

export function getUgid() {
  return "a12a1234-ab1a-1234-a123-1abc12a12abc";
}
export function getSessionId() {
  let sessionId: string | number | null = localStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = new Date().getTime();
    localStorage.setItem("sessionId", new String(sessionId).toString());
  }
  return sessionId;
}
export function getStoreUuid() {
  var uuid = localStorage.getItem("ZUID");
  if (!uuid) {
    uuid = createUuid();
    localStorage.setItem("ZUID", uuid);
  }
  return uuid;

  /*
   * 辅助生成zuid的方法
   * */
  function createUuid() {
    var str = "";
    if (isWechat() && isIos()) {
      //ios 微信
      str = "3";
    } else if (isWechat() && !isIos()) {
      //android 微信
      str = "4";
    } else if (isIos()) {
      //ios 客户端
      str = "1";
    } else {
      //android 客户端
      str = "2";
    }
    return (
      "xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }) +
      "|12345678900" +
      str
    );
  }
}

export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function getParamSearchByName(name: string) {
  var values = decodeURIComponent(
    (location.search.match(new RegExp("[?|&|/]" + name + "=([^&|?&]+)")) || ["", ""])[1]
  );
  return values || "";
}

export function wakeupApp() {
  if (isIos()) {
    window.location.href = "https://apps.apple.com/us/app/pondopeso/id1465541253?l=zh&ls=1";
  } else {
    window.location.href = `https://play.google.com/store/apps/details?id=ph.pondopeso.mnl.jk`;
  }
}
